import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["placeholder", "activePlaceholder", "limit", "maxSize", "fileTypes", "value", "onChange", "handleDownload"];
import React, { useCallback } from 'react';
import { FilePicker } from 'hoi-poi-ui';
import { useWeb5Context } from "../../../../lib/Web5Context";
function File(_ref) {
  let {
      placeholder,
      activePlaceholder,
      limit,
      maxSize,
      fileTypes,
      value = [],
      onChange,
      handleDownload
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const {
    t
  } = useWeb5Context();
  const onDrop = useCallback(acceptedFiles => {
    const finalValue = value || [];
    onChange && onChange([...finalValue, ...acceptedFiles]);
  }, [onChange, value]);
  const onRemove = useCallback(deletedFile => {
    onChange && onChange(value.filter(file => !(file.name === deletedFile.name && file.size === deletedFile.size && file.type === deletedFile.type)));
  }, [onChange, value]);
  return /*#__PURE__*/React.createElement(FilePicker, _extends({
    title: placeholder || t('cfm_label_drag_and_drop_and_upload'),
    activePlaceholder: activePlaceholder || t('cfm_label_drop_to_upload'),
    onDrop: onDrop,
    onRemove: onRemove,
    files: value || [],
    maxFiles: limit,
    maxSize: maxSize,
    accept: fileTypes,
    isFullWidth: true,
    handleDownload: handleDownload
  }, props));
}
process.env.NODE_ENV !== "production" ? File.propTypes = {} : void 0;
export default /*#__PURE__*/React.memo(File);